// This file is auto-generated by tools/load-env.js
// Do not modify directly - edit .env file instead

/**
 * Environment variables loaded from .env file
 * Access these constants instead of process.env in your Angular app
 */
export const ENV = {
  UNSPLASH_CLIENT_ID: '778111',
  UNSPLASH_KEY: 'UI1Zdycpi59roxTbZ_bzacchYY_Bfk0VdXzOuxwtFI0',
} as const;

// Type-safe helper to ensure all expected env vars are defined
export type EnvVars = typeof ENV;
